import React from "react";
import { server_var } from "../config/servervar";
import io from 'socket.io-client'
import { feathers } from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import authentication from '@feathersjs/authentication-client';
import FormData from 'form-data';
import axios from 'axios';
import { useState, useEffect } from "react";
import { View, Text } from 'react-native-web'
import Icon from '@mdi/react';
import { mdiAccount, mdiBasket, mdiCloseCircle, mdiPhone, mdiCamera, mdiImage, mdiSend, mdiNote, mdiChevronDown, mdiCloseCircleOutline, mdiCheckboxMarkedCircleOutline, mdiChevronUp, mdiPaperclip, mdiBellOutline, mdiChatOutline, mdiChat, mdiClock, mdiStore, mdiPill, mdiCalendar, mdiMap, mdiHistory, mdiChartBar, mdiHeadset } from '@mdi/js';
import { mdiShare, mdiVideo, mdiMinusCircle, mdiPlusCircle, mdiPlus, mdiAccountCircle, mdiChevronRightCircle } from '@mdi/js';
import { mdiCheckCircle, mdiCheckCircleOutline, mdiCheckboxBlankCircleOutline, mdiFile, mdiBook } from '@mdi/js';
import { mdiChatQuestion, mdiClose, mdiNoteOutline, mdiCircleMedium, mdiBookOpenVariant, mdiFileImagePlus } from '@mdi/js';
import { mdiPrinter, mdiBarcodeScan, mdiFileOutline, mdiBikeFast, mdiPlusCircleOutline, mdiVideoPlus } from '@mdi/js';
import { mdiCheckboxMarkedOutline, mdiCheckboxBlankOutline, mdiAlertCircleOutline, mdiExitToApp, mdiNotePlus, mdiTrashCanOutline, mdiCalendarClock } from '@mdi/js';
import { mdiFrequentlyAskedQuestions, mdiChevronLeft, mdiChevronRight, mdiHome, mdiMagnify, mdiEmail, mdiFacebook, mdiWeb, mdiClockAlertOutline } from '@mdi/js';
import { mdiChevronUpCircle, mdiChevronDownCircle } from '@mdi/js';
import { mdiNoteEditOutline, mdiFilePdfBox, mdiNoteTextOutline } from '@mdi/js';

export function getSocketClient() {
  const socket = io(server_var.server_api, {
    transports: ['websocket'],
    forceNew: true,
  });
  const client = feathers();
  client.configure(socketio(socket));
  client.configure(authentication({ storage: window.localStorage }));
  return { client, socket };
}

export async function appLogin(loginInfo, globalState, dispatch) {
  let res;
  try {
    console.log('poin1' + JSON.stringify(loginInfo));
    res = await globalState.client.authenticate(loginInfo);
    console.log('poin2');
    console.log('res', res.user);
    // if (res?.user?.roles != 'admin') {
    //   return null;
    // }
    dispatch({ type: 'setUser', payload: res.user })
    console.log('res', res);
    return res;
  } catch (e) {
    console.log('error', e)
    return null;
  }
}

export async function appReLogin(globalState, dispatch) {
  let res;
  try {
    res = await globalState.client.reAuthenticate();
    dispatch({ type: 'setUser', payload: res.user });
  } catch (e) { }
  return res;
}

export async function appLogout(globalState, dispatch) {
  globalState.client.logout();
  dispatch({ type: 'setUser', payload: null })
  return;
}

export function useCommon(globalState, dispatch) {
  appReLogin(globalState, dispatch);
  return;
}

export async function uploadPhoto(mode, multiple, photoType, targetFiles) {
  let retImage = [];
  const jwtToken = await getJwtToken();

  let uploadTo = mode;
  if (mode == 'banner') {
    uploadTo = 'feed';
  }
  if (mode == 'avatar') {
    uploadTo = 'profile';
  }
  for (const item of targetFiles) {
    const form = new FormData();
    const headers = form.getHeaders ? form.getHeaders() : { 'Content-Type': 'multipart/form-data' };
    form.append("tmpFile", (item));
    const jwtToken = await getJwtToken();
    let originalFileName = item.name;
    const config = { headers: { ...headers, jwtToken }, params: { uploadTo, originalFileName } };
    const uploadResult = await axios.post(`${server_var.server_api}/uploadFile`, form, config);
    console.log('\n\n\nuploadResult2', uploadResult.data);
    const fileName = uploadResult?.data?.fileName;
    const fullPath = uploadResult?.data?.fullPath;
    const fullPathNonCompress = uploadResult?.data?.fullPathNonCompress;
    console.log('fileName:' + fileName);
    retImage.push({ filename: fileName, fullpath: fullPath, fullPathNonCompress: fullPathNonCompress });
  }
  return retImage;
};

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);
  return debouncedValue;
}

export function CustomIcon({ name, size, color }) {
  const mapping = [
    { name: 'camera', icon: mdiCamera },
    { name: 'image', icon: mdiImage },
    { name: 'send', icon: mdiSend },
    { name: 'basket', icon: mdiBasket },
    { name: 'account', icon: mdiAccount },
    { name: 'account-circle', icon: mdiAccountCircle },
    { name: 'close-circle', icon: mdiCloseCircle },
    { name: 'phone', icon: mdiPhone },
    { name: 'note', icon: mdiNote },
    { name: 'share', icon: mdiShare },
    { name: 'video', icon: mdiVideo },
    { name: 'minus-circle', icon: mdiMinusCircle },
    { name: 'plus-circle', icon: mdiPlusCircle },
    { name: 'plus', icon: mdiPlus },
    { name: 'check-circle', icon: mdiCheckCircle },
    { name: 'check-circle-outline', icon: mdiCheckCircleOutline },
    { name: 'checkbox-blank-circle-outline', icon: mdiCheckboxBlankCircleOutline },
    { name: 'file', icon: mdiFile },
    { name: 'book', icon: mdiBook },
    { name: 'chat-question', icon: mdiChatQuestion },
    { name: 'close', icon: mdiClose },
    { name: 'note-outline', icon: mdiNoteOutline },
    { name: 'circle-medium', icon: mdiCircleMedium },
    { name: 'printer', icon: mdiPrinter },
    { name: 'barcode-scan', icon: mdiBarcodeScan },
    { name: 'file-outline', icon: mdiFileOutline },
    { name: 'bike-fast', icon: mdiBikeFast },
    { name: 'checkbox-marked-outline', icon: mdiCheckboxMarkedOutline },
    { name: 'checkbox-blank-outline', icon: mdiCheckboxBlankOutline },
    { name: 'alert-circle-outline', icon: mdiAlertCircleOutline },
    { name: 'exit-to-app', icon: mdiExitToApp },
    { name: 'note-edit-outline', icon: mdiNoteEditOutline },
    { name: 'file-pdf-box', icon: mdiFilePdfBox },
    { name: 'chevron-down', icon: mdiChevronDown },
    { name: 'chevron-up', icon: mdiChevronUp },
    { name: 'chevron-right', icon: mdiChevronRight },
    { name: 'check-circle-outline', icon: mdiCheckCircleOutline },
    { name: 'checkbox-blank-circle-outline', icon: mdiCheckboxBlankCircleOutline },
    { name: 'close-circle-outline', icon: mdiCloseCircleOutline },
    { name: 'checkbox-marked-circle-outline', icon: mdiCheckboxMarkedCircleOutline },
    { name: 'checkbox-blank-circle-outline', icon: mdiCheckboxBlankCircleOutline },
    { name: 'paperclip', icon: mdiPaperclip },
    { name: 'account-details', icon: mdiAccount },
    { name: 'bell-outline', icon: mdiBellOutline },
    { name: 'chat', icon: mdiChat },
    { name: 'clock', icon: mdiClock },
    { name: 'store', icon: mdiStore },
    { name: 'pill', icon: mdiPill },
    { name: 'calendar', icon: mdiCalendar },
    { name: 'map', icon: mdiMap },
    { name: 'history', icon: mdiHistory },
    { name: 'chart-bar', icon: mdiChartBar },
    { name: 'headset', icon: mdiHeadset },
    { name: 'frequently-asked-questions', icon: mdiFrequentlyAskedQuestions },
    { name: 'chevron-left', icon: mdiChevronLeft },
    { name: 'home', icon: mdiHome },
    { name: 'magnify', icon: mdiMagnify },
    { name: 'email', icon: mdiEmail },
    { name: 'facebook', icon: mdiFacebook },
    { name: 'web', icon: mdiWeb },
    { name: 'book-open-variant', icon: mdiBookOpenVariant },
    { name: 'plus-circle-outline', icon: mdiPlusCircleOutline },
    { name: 'chevron-right-circle', icon: mdiChevronRightCircle },
    { name: 'file-image-plus', icon: mdiFileImagePlus },
    { name: 'video-plus', icon: mdiVideoPlus },
    { name: 'note-plus', icon: mdiNotePlus },
    { name: 'trash-can-outline', icon: mdiTrashCanOutline },
    { name: 'clock-alert-outline', icon: mdiClockAlertOutline },
    { name: 'calendar-clock', icon: mdiCalendarClock },
    { name: 'chevron-up-circle', icon: mdiChevronUpCircle },
    { name: 'chevron-down-circle', icon: mdiChevronDownCircle },
    { name: 'note-plus', icon: mdiNotePlus },
    { name: 'note-text-outline', icon: mdiNoteTextOutline },
  ]

  const iconPath = mapping.find(item => item.name == name)?.icon
  if (iconPath) {
    return (
      <Icon path={mapping.find(item => item.name == name).icon}
        size={size / 24}
        color={color} />
    )
  } else {
    return (
      <View>
        <Text>icon {name}</Text>
      </View>
    )
  }
}

export async function getJwtToken() {
  return window.localStorage.getItem('feathers-jwt');
}


